const projects = [
  {
    id: 8,
    title: "Organa",
    description: "Serveur role play sur la plateforme FiveM  .",
    descriptionModale:
      "Un projet personnel pour un serveur Gta5. Cette application est un site vitrine qui pourrait évoluer vers une boutique.",
    image: require("../assets/projects/organa1.png"),
    imagesModale: [
      require("../assets/projects/organa1.png"),
      require("../assets/projects/organa2.png"),
    ],
    category: "App Web",
    year: "2024",
    technologies: ["HTML", "CSS", "REACT", "SASS"],
    siteUrl: "https://organa-rp.vizir-dev.fr/",
    githubLink: "https://github.com/charles-lgs/Horizon-RP",
  },
  {
    id: 1,
    title: "Kasa",
    description: "Agence de location d'appartements entre particuliers.",
    descriptionModale:
      "Le site de Kasa a été codé il y a maintenant plus de 10 ans en ASP.NET avec un code legacy important. Le projet consistait à une refonte totale vers une application React côté front-end.",
    image: require("../assets/projects/kasa.png"),
    imagesModale: [
      require("../assets/projects/kasa.png"),
      require("../assets/projects/kasa-2.png"),
    ],
    category: "App Web",
    year: "2024",
    technologies: ["HTML", "CSS", "REACT", "SASS"],
    siteUrl: "",
    githubLink: "https://github.com/charles-lgs/Kasa",
  },
  {
    id: 2,
    title: "Sophie Bluel",
    description:
      "Portfolio de Sophie Bluel, une architecte d'intèrieur indépendante.",
    descriptionModale:
      "Pour l’agence ArchiWebos, il fallait améliorer le portfolio de Sophie Bluel en ajoutant un mode administrateur avec une page de connexion communiquant avec une API Swagger pour l'ajout et la suppression de projets de façon dynamique.",
    image: require("../assets/projects/sophie-bluel.png"),
    imagesModale: [
      require("../assets/projects/sophie-bluel.png"),
      require("../assets/projects/sophie-bluel-2.png"),
    ],
    category: "Site Web",
    year: "2024",
    technologies: ["HTML", "CSS", "JS", "SASS"],
    siteUrl: "",
    githubLink:
      "https://github.com/charles-lgs/Portfolio-architecte-sophie-bluel",
  },
  {
    id: 3,
    title: "Ohmyfood",
    description:
      "Application en mobile first de réservation de restaurants sur Paris.",
    descriptionModale:
      "Une mission qui consistait à développer le front-end d'un site en mobile first en suivant la maquette de l'UX designer et du prototype pour les animations.",
    image: require("../assets/projects/ohmyfood.png"),
    imagesModale: [
      require("../assets/projects/ohmyfood.png"),
      require("../assets/projects/ohmyfood-2.png"),
    ],
    category: "Site Web",
    year: "2024",
    technologies: ["HTML", "CSS", "SASS"],
    siteUrl: "https://charles-lgs.github.io/Ohmyfood/",
    githubLink: "https://github.com/charles-lgs/Ohmyfood",
  },
  {
    id: 4,
    title: "Nina Carducci",
    description: "Optimisation des performances et référencement SEO.",
    descriptionModale:
      "Pour cette mission il fallait améliorer les performances et le référencement SEO pour que le rapport Lighthouse soit sur tout les points supérieur à 90%",
    image: require("../assets/projects/nina-carducci.png"),
    imagesModale: [
      require("../assets/projects/nina-carducci.png"),
      require("../assets/projects/nina-carducci-2.png"),
    ],
    category: "Site Web",
    year: "2024",
    technologies: ["HTML", "CSS"],
    siteUrl: "https://charles-lgs.github.io/Nina-Carducci/",
    githubLink: "https://github.com/charles-lgs/Nina-Carducci",
  },
  {
    id: 5,
    title: "Booki",
    description: "Startup présentant des hébergements et activités par ville.",
    descriptionModale:
      "Développer un site Internet permettant aux utilisateurs de trouver des hébergements et des activités dans la ville de leur choix.",
    image: require("../assets/projects/booki.png"),
    imagesModale: [
      require("../assets/projects/booki.png"),
      require("../assets/projects/booki-2.png"),
    ],
    category: "Site Web",
    year: "2024",
    technologies: ["HTML", "CSS"],
    siteUrl: "https://charles-lgs.github.io/Booki/",
    githubLink: "https://github.com/charles-lgs/Booki",
  },
  {
    id: 6,
    title: "724 Events",
    description:
      "Mission de débogage et d'optimisation pour un site d'évènementiel.",
    descriptionModale:
      "Prendre la suite du développeur à la base de la conception du site pour déboguer l'application et réaliser les teste généraux et unitaires.",
    image: require("../assets/projects/724-events.png"),
    imagesModale: [
      require("../assets/projects/724-events.png"),
      require("../assets/projects/724-events-2.png"),
    ],
    category: "Site Web",
    year: "2024",
    technologies: ["HTML", "CSS", "REACT", "SASS"],
    siteUrl: "",
    githubLink: "https://github.com/charles-lgs/724events",
  },
  {
    id: 7,
    title: "Print it!",
    description:
      "Création d'un carrousel d'images pour le site d'une imprimerie.",
    descriptionModale:
      "Création d'un carrousel d'images en bannière sur la page principale du site d'une imprimerie d'entreprise.",
    image: require("../assets/projects/print-it.png"),
    imagesModale: [
      require("../assets/projects/print-it.png"),
      require("../assets/projects/print-it-2.png"),
    ],
    category: "Site Web",
    year: "2024",
    technologies: ["HTML", "CSS", "JS"],
    siteUrl: "https://charles-lgs.github.io/Print-it-/",
    githubLink: "https://github.com/charles-lgs/Print-it-",
  },
];

export default projects;
